module.exports = __webpack_public_path__ + "static/media/img129_R.a5c697e7.jpg";